export default __webpack_public_path__ + "static/media/full_bundle_guide_me_3_strip@2x.d5915736.webp";